import './Header.css'
import React from 'react'
import logo from '../../assets/images/logo.png'

export default () => 
    <header className="header">
        <h1> Vai Pescar </h1> 
        <div className="logo">
          <img  src={logo} alt="anzol" width={60}/>
        </div>
    </header>